<script setup>
import useGrid from "@/composables/useGrid";
import savedSearchesService from "@/services/saved-searches.service";
import {ref} from "vue";
import TablePager from "@/components/TablePager.vue";
import SearchesList from "@/views/enterprise/home/content/searches/SearchesList.vue";

const {gridParams, gridMethods, items} = useGrid(getSearchesIndexList, 6);
const showModal = ref(false);

function getSearchesIndexList(pageParams) {
    return savedSearchesService.getIndexList(pageParams);
}

function open() {
    gridMethods.loadIfNotLoaded();
    showModal.value = true;
}

defineExpose({open});
</script>

<template>
    <b-modal v-model="showModal" title="Saved Searches" modal-class="modal-searches" hide-footer>
        <SearchesList :searches="items"/>
        
        <TablePager
            v-if="items.length"
            :pages-count="gridParams.pagesCount"
            :init-page="gridParams.currentPage"
            @changePage="gridMethods.changePage"
        />
    </b-modal>
</template>

<style scoped>

</style>
